/* eslint-disable react/no-danger */
import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Card,
  Divider,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

/**
 * A dialog component that displays a list of unseen alerts
 * @param {object} props component props
 * @param {boolean} props.open Whether the dialog is open or not
 * @param {Array} props.unseenAlerts An array of unseen alerts
 * @param {boolean} props.loadingAlerts Whether the alerts are currently being loaded
 * @param {Function} props.closeDialog A function to call when the dialog is closed
 * @param {Function} props.markAsRead A function to call when an alert is marked as read
 * @param {boolean} props.acknowledgingAlert Whether an alert is currently being acknowledged
 */
function NotificationDialog({
  open = false,
  unseenAlerts = [],
  loadingAlerts = false,
  closeDialog = () => {},
  markAsRead = () => {},
  acknowledgingAlert = false,
}) {
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState(undefined);

  const classes = useStyles();
  const unseenAlertsMap = unseenAlerts.map(unseenAlert => {
    const maxLength = 100;

    const truncatedDescription =
      unseenAlert.description && unseenAlert.description.length > maxLength
        ? `${unseenAlert.description.substring(0, maxLength)}...`
        : unseenAlert.description;

    return (
      <Card
        key={unseenAlert.id}
        style={{
          marginBottom: 10,
          borderRadius: 5,
        }}
      >
        <div style={{ padding: 15, marginLeft: 10, fontWeight: "bold" }}>
          {unseenAlert.title}
        </div>
        <div
          style={{ padding: 15, marginLeft: 10 }}
          dangerouslySetInnerHTML={{ __html: truncatedDescription }}
        />
        <Divider />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{ margin: 15 }}
            onClick={() => {
              setShowAlert(true);
              setAlert(unseenAlert);
            }}
            color="primary"
          >
            View
          </Button>
        </div>
      </Card>
    );
  });
  return (
    <>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={() => {
          closeDialog();
        }}
      >
        <DialogTitle>Your Alerts</DialogTitle>
        <DialogContent>
          {loadingAlerts ? (
            <div>
              <Typography variant="body1" style={{ textAlign: "center" }}>
                Loading...
              </Typography>
            </div>
          ) : unseenAlerts.length === 0 ? (
            <div>
              <Typography variant="body1" style={{ textAlign: "center" }}>
                All caught up...
              </Typography>
            </div>
          ) : (
            unseenAlertsMap
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              closeDialog();
            }}
            color="primary"
          >
            Dismiss
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={showAlert} onClose={() => setShowAlert(false)}>
        {alert && (
          <>
            <DialogTitle>{alert.title}</DialogTitle>
            {alert.image && (
              <div className={classes.alertImageContainer}>
                <img
                  src={alert.image}
                  alt={alert.title}
                  style={{ width: "auto", maxHeight: 250 }}
                />
              </div>
            )}
            <DialogContent>
              <div
                style={{ padding: 15, marginLeft: 10 }}
                dangerouslySetInnerHTML={{ __html: alert.description }}
              />
            </DialogContent>
            <Divider />
            <DialogActions className={classes.alertActions}>
              <Button
                onClick={() => {
                  markAsRead(alert);
                  setShowAlert(false);
                  setAlert(undefined);
                }}
                color="primary"
              >
                {acknowledgingAlert ? "Loading..." : "Got It"}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}

export default NotificationDialog;

const useStyles = () =>
  makeStyles(() => ({
    alertImageContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 10,
    },
  }))();
